import * as types from "./types";
import { getFExp, getFToken } from "./actions";

const initialState = {
  token: getFToken(),
  expiresAt: getFExp()
} as types.FacebookState;

export default function reducer(
  state = initialState,
  action: types.FacebookAction
): types.FacebookState {
  switch (action.type) {
    case types.CHANGE_FACEBOOK_TOKEN:
      return {
        ...state,
        token: action.token,
        expiresAt: action.expiresAt
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/facebook/reducer.ts